import Link from "next/link";
import Image from "next/image";
import { ArrowLeft } from "lucide-react";
import { Button } from "@workspace/ui/components";
import { ReactNode } from "react";

export const DesktopHeader = ({
  title,
  returnPath,
  action,
}: {
  title?: string;
  returnPath?: string;
  action?: ReactNode;
}) => {
  return (
    <div className="hidden md:block pb-[10px] pl-[20px] pr-[10px] pt-[20px] w-full">
      <div className="bg-white border border-[#e3d8c4] border-solid flex flex-col items-start p-[20px] rounded-[24px] shadow-[0px_4px_4px_0px_rgba(41,37,36,0.12)]">
        <div className="flex gap-[32px] items-center w-full">
          <div className="flex flex-1 gap-[24px] items-center">
            <div className="flex items-center shrink-0">
              <Image
                src="/logo.svg"
                alt="Yolk"
                width={116}
                height={40}
                className="h-[40px] w-[115.702px]"
              />
            </div>
            <div className="flex gap-[24px] items-center shrink-0">
              {returnPath && (
                <Button variant="d-default" asChild className="p-1.5 size-10">
                  <Link href={returnPath}>
                    <ArrowLeft className="size-[16px] text-[#292524]" />
                  </Link>
                </Button>
              )}
              <p className="font-semibold leading-[28px] shrink-0 text-[22px]">
                {title}
              </p>
            </div>
          </div>
          {action || (
            <Button variant="d-default" className="size-10 p-1.5">
              <Image src="/icons/dots.svg" width={24} height={24} alt="dots" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
